<template>
  <VaDropdown v-model="isShown" :offset="[9, 0]" stick-to-edges>
    <template #anchor>
      <VaChip icon="mso-store" outline class="mr-2 w-max cursor-pointer">
        <span class="line-clamp-1 max-w-40">{{ getCurrentCompany('tradeName') }}</span>
        <VaIcon name="mso-unfold_more" color="secondary" class="ml-2" />
      </VaChip>
    </template>
    <VaDropdownContent class="w-full px-0 py-4 hover:bg-backgroundPrimary md:w-60">
      <VaList>
        <header class="flex w-full items-center justify-between px-4 pb-2">
          <p class="va-title text-secondary opacity-80">Conta</p>
          <VaBadge text="básico" color="info" />
        </header>

        <VaListItem class="px-4 py-2 hover:bg-backgroundPrimary" :to="{ name: 'planos' }">
          <div class="flex items-center gap-2">
            <VaIcon name="mso-diamond_shine" color="info" size="20px" />
            <p>Atualizar Plano</p>
          </div>
        </VaListItem>

        <VaListItem
          class="px-4 py-2 hover:bg-backgroundPrimary"
          href="https://wa.me/5541988514680?text=Olá! Preciso de ajuda e suporte com o painel empresas Rolê de Boa."
          target="_blank"
        >
          <div class="flex items-center gap-2">
            <VaIcon name="mso-contact_support" color="primary" size="20px" />
            <p>Ajuda e Suporte</p>
          </div>
        </VaListItem>

        <VaListItem class="px-4 py-2 hover:bg-backgroundPrimary" :to="{ name: 'configuracoes' }">
          <div class="flex items-center gap-2">
            <VaIcon name="mso-settings" color="primary" size="20px" />
            <p>Configurações</p>
          </div>
        </VaListItem>

        <VaDivider />

        <VaListItem class="cursor-pointer px-4 py-2 hover:bg-backgroundPrimary" @click="logout">
          <div class="flex items-center gap-2">
            <VaIcon name="mso-logout" color="primary" size="20px" />
            <p>Sair</p>
          </div>
        </VaListItem>
      </VaList>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useCompanyStore } from '@/features/companies'
import { authServices } from '@/features/auth'

const { push } = useRouter()
const isShown = ref(false)

const { getCurrentCompany } = useCompanyStore()

const logout = async () => {
  const { ok } = await authServices.signOut()
  ok && push({ name: 'login' })
}
</script>
